import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Trophy, PartyPopper } from "lucide-react";

export const WinnerShoutout = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/dashboard/shoutout").then(({ data: d }) => { if (d.show) { setData(d); } }).catch(() => {});
  }, []);
  const close = () => {
    setData(null);
    api.post("/dashboard/shoutout/seen").catch(() => {});
  };
  if (!data) { return null; }
  const first = data.winner.name.split(" ")[0];
  return (
    <Dialog open onOpenChange={(o) => { if (!o) { close(); } }}>
      <DialogContent className="max-w-md p-0 overflow-hidden border-2 border-red-600 rounded-sm bg-slate-950 text-white" data-testid="winner-shoutout">
        <div className="relative p-8 text-center">
          <Trophy className="absolute -right-8 -top-8 h-40 w-40 text-red-600/15" strokeWidth={1} />
          <div className="mx-auto h-20 w-20 rounded-full bg-red-600 flex items-center justify-center shadow-lg shadow-red-600/40 aotm-glow">
            <Trophy className="h-10 w-10 text-white" strokeWidth={1.75} />
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-red-400 mt-6">Agent of the Month &middot; {data.label}</div>
          <DialogTitle className="font-display text-3xl font-black tracking-tight mt-2 text-white" data-testid="shoutout-name">{data.winner.name}</DialogTitle>
          <DialogDescription className="text-slate-300 mt-3 text-sm" data-testid="shoutout-message">
            {data.is_you
              ? `Congratulations ${first}! You solved ${data.winner.solved} tickets last month - thank you for leading the team.`
              : `Please congratulate ${first} - ${data.winner.solved} tickets solved last month. Great work for the whole team!`}
          </DialogDescription>
          <Button onClick={close} className="mt-6 bg-red-600 hover:bg-red-500 rounded-sm h-11 px-6" data-testid="shoutout-close-btn">
            <PartyPopper className="h-4 w-4" strokeWidth={1.75} /> {data.is_you ? "Thank you!" : "Congratulations!"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
